/**
 * Theme helpers — convert hex (#RRGGBB) to RGB triple "r g b" used by
 * Tailwind's rgb(var(--c-x) / <alpha-value>) pattern.
 */

export const THEME_KEYS = [
  { key: "theme_bg", cssVar: "--c-bg", label: "Background", default: "#0a0a0a" },
  { key: "theme_bg_soft", cssVar: "--c-bg-soft", label: "Panel", default: "#171717" },
  { key: "theme_text", cssVar: "--c-text", label: "Text", default: "#f5f1ea" },
  { key: "theme_muted", cssVar: "--c-muted", label: "Muted", default: "#d8cdb8" },
  { key: "theme_accent", cssVar: "--c-accent", label: "Accent", default: "#c8602c" },
  {
    key: "theme_accent_soft",
    cssVar: "--c-accent-soft",
    label: "Accent hover",
    default: "#e07a43",
  },
];

const FONT_STACKS = {
  display: '"Fraunces", Georgia, serif',
  serif: 'Georgia, "Times New Roman", serif',
  sans: '"Inter", system-ui, sans-serif',
  mono: '"JetBrains Mono", monospace',
};

function numberInRange(value, fallback, min, max) {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(max, Math.max(min, n));
}

export function hexToRgbTriple(hex) {
  if (!hex || typeof hex !== "string") return null;
  const m = hex.trim().match(/^#?([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (!m) return null;
  let h = m[1];
  if (h.length === 3) {
    h = h
      .split("")
      .map((c) => c + c)
      .join("");
  }
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `${r} ${g} ${b}`;
}

export function applyTheme(content) {
  if (!content || typeof window === "undefined") return;
  const root = document.documentElement;
  for (const { key, cssVar, default: dflt } of THEME_KEYS) {
    const triple = hexToRgbTriple(content[key] || dflt);
    if (triple) root.style.setProperty(cssVar, triple);
  }
  root.style.setProperty(
    "--site-body-font",
    FONT_STACKS[content.theme_body_font] || FONT_STACKS.sans
  );
  root.style.setProperty(
    "--site-spacing-scale",
    String(numberInRange(content.theme_spacing_scale, 100, 70, 140) / 100)
  );
  root.style.setProperty(
    "--site-button-radius",
    `${numberInRange(content.theme_button_radius, 0, 0, 24)}px`
  );
  root.dataset.buttonStyle = content.theme_button_style || "outline";
}
